import { on, removeListener } from "api/prokey/prokey.websocket";
import React, { createContext, useEffect, useRef, useState } from "react"

const TaskContext = createContext()

//-----------------------------------------------------------------
function TaskProvider( { children } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const [ task      , setTask      ] = useState( {} );
  const [ documents , setDocuments ] = useState( {} );
  const [ blocks    , setBlocks    ] = useState( {} );
  const [ fields    , setFields    ] = useState( {} );

  const ref_images = useRef( new Map() );

  const values = {
    images: ref_images.current, clearImages,
  };

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleImage(data) {
      //-----------------------------------------------------------------
      if( ref_images.current.has( data?.id ) ) return;

      const temp = document.createElement('img');
      
      temp.onload = function() {
        data.html_image = temp;
        ref_images.current.set(data.id , data );
      };
      
      temp.onError = function() {
      }

      temp.src = data?.url;
    }

    on( 'IMAGE', handleImage );

    return () => {
      removeListener( 'IMAGE' , handleImage );
    };
  }, [] );

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleTask(data) {
      //-----------------------------------------------------------------
      if( data?.id === task.id ) return;

      setTask( data );
      ref_images.current = new Map();
    }

    on( 'TASK_INFO', handleTask );

    return () => {
      removeListener( 'TASK_INFO' , handleTask );
    };
  }, [] )

  //#endregion

  //#region [METHOD]

  //-----------------------------------------------------------------
  function clearImages() {
    //-----------------------------------------------------------------
    ref_images.current = new Map();
  }

  //#endregion

  return (
    <TaskContext.Provider value={ values }>
      {children}
    </TaskContext.Provider>
  );
};

export { TaskContext, TaskProvider };